import React from 'react';

import style from './styles.module.css';

interface TextareaProps {
  label?: string;
  placeholder?: string;
  text: string;
  onTextChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  disabled?: boolean;
  maxLength?: number;
}

export const Textarea: React.FC<TextareaProps> = ({
  label,
  placeholder = 'Digite aqui...',
  text,
  onTextChange,
  disabled = false,
  maxLength,
}) => {
  const id = Math.random().toString(36).substring(7);

  return (
    <div className={style.textareaContainer}>
      {label && (
        <label htmlFor={id} className={style.label}>
          <span id={id} dangerouslySetInnerHTML={{ __html: label }} />
        </label>
      )}
      <textarea
        id={id}
        className={style.textarea}
        placeholder={placeholder}
        value={text}
        onChange={onTextChange}
        disabled={disabled}
        maxLength={maxLength}
      />
    </div>
  );
};
